<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickExcelExport()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <m-search-filters
        :filter_options="filter_options"
        v-model="search_filters"
        v-on:input="doUpdate"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        :loading="loading"
    >
    
        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create, 'date')}}
        </template>

        <template v-slot:item.time_create_time="{ item }">
            {{$rc.pretty(item.time_create, 'time')}}
        </template>

        <template v-slot:item.placed="{ item }">
             <v-simple-checkbox
                 :value="item.placed ?? true"
                 :disabled="item.placed == null"
             />
        </template>

        <template v-slot:item.cancelled="{ item }">
             <v-simple-checkbox
                 :value="item.cancelled ?? false"
                 :disabled="item.cancelled == null"
             />
        </template>

        <template v-slot:item.first_fulfillment_date="{ item }">
             <span v-if="item.cancelled != true">
                {{item.first_fulfillment_date}}
             </span>
        </template>

        

       

        <template v-slot:item.customer_phone_numbers="{ item }">
            <div
                v-for="(number, index) in item.endpoints"
                :key="'number_'+index"
            >
                {{$rc.pretty(number,'endpoint')}}
            </div>
        </template>

        <template v-slot:item.emails="{ item }">
            <div
                v-for="(email, index) in item.emails"
                :key="'email_'+index"
            >
                {{email}}
            </div>
        </template>

        <template v-slot:item.tracking_numbers="{ item }">
            <div
                v-for="(tn, index) in item.tracking_numbers"
                :key="'tracking_number_'+index"
            >
                {{tn}}
            </div>
        </template>

        
        <template v-slot:item.ship_to_address="{ item }">
            <span v-if="item.ship_to_address">
                {{item.ship_to_address}}
            </span>
        </template>

        <template v-slot:item.bill_to_address="{ item }">
            <span v-if="item.bill_to_address">
                {{item.bill_to_address}}
            </span>
        </template>

        <template v-slot:item.ship_to_endpoints="{ item }">
            <div
                v-for="(endpoint, index) in item.ship_to_endpoints"
                :key="'ship_to_endpoint_'+index"
            >
                {{$rc.pretty(endpoint,'endpoint')}}
            </div>
        </template>

        <template v-slot:item.bill_to_endpoints="{ item }">
            <div
                v-for="(endpoint, index) in item.bill_to_endpoints"
                :key="'bill_to_endpoint_'+index"
            >
                {{$rc.pretty(endpoint,'endpoint')}}
            </div>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewInCrm(item)"
                    v-if="item.url_view_order_in_crm != null"
                >
                    <v-list-item-title>View in {{crm_name}}...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div
        v-if="$route.params.content_type == 'commerce7'"
        style="margin-top: 15px"
    >
        <b>Notes</b>
        <ul>
            <li>An order is considered cancelled if it has been refunded.</li>
            <li>Cancelled orders will not be counted toward order attribution (it may take up to 24 hours after cancelling for the order attribution to be removed).</li>
            <li>Email addresses may be missing for old orders until you perform a deep resync (tracking email address is a new feature as of 2024-04-07)</li>
        </ul>
    </div>

    <div
        v-if="$route.params.content_type == 'ecellar'"
        style="margin-top: 15px"
    >
        <b>Notess</b>
        <ul>
            <li>An order is considered cancelled if it is in either the "cancelled" or "void" state.</li>
            <li>Cancelled orders will not be counted toward order attribution (it may take up to 24 hours after cancelling for the order attribution to be removed).</li>
            <li>Email addresses may be missing for old orders until you perform a deep resync (tracking email address is a new feature as of 2024-04-07)</li>
        </ul>
    </div>

    <div
        v-if="$route.params.content_type == 'winedirect'"
        style="margin-top: 15px"
    >
        <b>Notes</b>
        <ul>
            <li>Orders that have not been placed (i.e. pending orders) and cancelled orders will not be counted toward order attribution (it may take up to 24 hours after cancelling for the order attribution to be removed).</li>
            <li>Email addresses may be missing for old orders until you perform a deep resync (tracking email address is a new feature as of 2024-04-07)</li>
        </ul>

    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            loading: false,
            full_text: null,
            results: [],
            search_filters: [],
            filter_options: [{
                'column_label': 'Order Date',
                'column_id': 'time_create',
                'type': 'date-in-range-inclusive',
                'transform_values': {
                    'type': 'date-range-to-millis',
                    'organization_id': this.$route.params.organization_id,
                }
            }],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.loading = true;

            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/orders',
            
                {
                    'full_text': this.full_text,
                    'search_filters': this.search_filters,
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                    'sort': 'time_create:desc',
                },
            
                (data) => {
                    this.results = data.results;
                    this.loading = false;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search orders');
                    this.loading = false;
                },
            );
        },

        onClickExcelExport()
        {
            if ( this.search_filters.length == 0 )
            {
                this.$rc.confirm({
                    'title': 'Export all orders?',
                    'body': 'You do not currently have any search filter (e.g. order date) applied to you order search.<br/><br/>As a result <b>all orders</b> will be exported<br/><br/>This can take a very long time and RedChirp will only export the most recent 100,000 orders.<br/><br/>We suggest you filter by date range before exporting.',
                    'btn_text_ok': 'Export Anyway',
                    'btn_text_cancel': 'Cancel',
                    'on_ok': () => {
                        this.doExcelExport();
                    },
                });
            }
            else
            {
                this.doExcelExport();
            }
        },

        doExcelExport()
        {
            this.$rc.excelExport(
                'EXPORT: /api/v1/integrations/crm/orders',
                {
                    'search_filters': this.search_filters,
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                    'sort': 'time_create:desc',
                }
            );
        },

        onClickViewInCrm(item)
        {
            window.open(item.url_view_order_in_crm,"_blank");
        },

        onClickTechnicalData(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': item,
                });
        },
        
    },

    computed: {
        title() {
            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Orders';
        },

        crm_name() {
            return this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name');
        },

        headers() {
            let ret = [
                { text: 'Brand', value: 'brand_label'},
                { text: 'Date', value: 'time_create_date'},
                { text: 'Time', value: 'time_create_time'},
                { text: 'Type', value: 'order_type' },
                { text: 'Number', value: 'order_number' },
                { text: 'First Name', value: 'customer_first_name'},
                { text: 'Last Name', value: 'customer_last_name'},
                { text: 'Phone', 'value' : 'customer_phone_numbers' },
                { text: 'Email', 'value' : 'emails' },
            ];

            if ( this.$route.params.content_type == 'winedirect' )
            {
                ret.push({ text: 'Placed', 'value': 'placed' });
            }
                
            ret.push({ text: 'Cancelled', 'value': 'cancelled' }); 

            if ( this.$route.params.content_type != 'order-port' )
            {
                ret.push({ text: 'Delivery Method', 'value' : 'delivery_method' });
            }

            ret.push({ text: 'First Fulfillment', value: 'first_fulfillment_date'});
            ret.push({ text: 'Tracking Numbers', value: 'tracking_numbers'});

            const has_ship_to = this.results && this.results.some(item => 
                item.ship_to_endpoints && item.ship_to_endpoints.length > 0
            );
            if (has_ship_to) 
            {
                ret.push({ text: 'Ship To Phone', value: 'ship_to_endpoints'});
            }
            
            const has_bill_to = this.results && this.results.some(item => 
                item.bill_to_endpoints && item.bill_to_endpoints.length > 0
            );

            if (has_bill_to) 
            {
                ret.push({ text: 'Bill To Phone', value: 'bill_to_endpoints'});
            }
            
            ret.push({ text: 'Action', value: 'action'});
        
            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>